import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, vModelText as _vModelText, withDirectives as _withDirectives, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "w100" }
const _hoisted_2 = { key: 0 }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("label", { class: "fl fs14 dgrey mb5 mt5" }, "選択期間を設定", -1)
const _hoisted_4 = { class: "" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_6 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_7 = { key: 0 }
const _hoisted_8 = { key: 1 }
const _hoisted_9 = { key: 2 }
const _hoisted_10 = { class: "fl mt5 mr10" }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("p", { class: "fl mt30 ml10" }, "日後から", -1)
const _hoisted_12 = { class: "fl mt5" }
const _hoisted_13 = /*#__PURE__*/_createElementVNode("p", {
  class: "fl mt30 ml10",
  style: {}
}, "日後まで", -1)
const _hoisted_14 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_15 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_16 = { key: 3 }
const _hoisted_17 = { style: {"padding-left":"140px"} }
const _hoisted_18 = { class: "input-group" }
const _hoisted_19 = /*#__PURE__*/_createElementVNode("p", { class: "fl mt7 ml5 mr5" }, "~", -1)
const _hoisted_20 = { class: "input-group" }
const _hoisted_21 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_22 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_23 = /*#__PURE__*/_createElementVNode("label", {
  for: `restrict_date_`,
  class: "fs13 pointer"
}, " 選択できる日を厳密にする", -1)
const _hoisted_24 = {
  key: 4,
  class: "fs13 fw600"
}
const _hoisted_25 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_26 = { key: 1 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_MdTextfieldTag = _resolveComponent("MdTextfieldTag")!
  const _component_DatePicker = _resolveComponent("DatePicker")!
  const _component_Dropdown = _resolveComponent("Dropdown")!
  const _component_CheckboxTag = _resolveComponent("CheckboxTag")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.useBirthdatePeriod)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("div", null, [
            _hoisted_3,
            _createElementVNode("div", _hoisted_4, [
              (_ctx.selectedType == _ctx.FormField.RELATIVE_TIME_RANGE)
                ? (_openBlock(), _createElementBlock("p", {
                    key: 0,
                    class: "fr fw600 underline dblue pointer mt5",
                    onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.changeBirthdateSpanType(`absolute_time_range`)))
                  }, " 絶対期間に切り替える "))
                : (_ctx.selectedType == _ctx.FormField.ABSOLUTE_TIME_RANGE)
                  ? (_openBlock(), _createElementBlock("p", {
                      key: 1,
                      class: "fr fw600 underline dblue pointer mt5",
                      onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.changeBirthdateSpanType(`relative_time_range`)))
                    }, " 相対期間に切り替える "))
                  : _createCommentVNode("", true)
            ]),
            _hoisted_5
          ]),
          _hoisted_6,
          (_ctx.currentBirthDateOption.restrict_date)
            ? (_openBlock(), _createElementBlock("div", _hoisted_7, "設定した期間のみを選択できるようになります。"))
            : (_openBlock(), _createElementBlock("div", _hoisted_8, "設定した期間の年初から年末までの年を選択できるようになります。")),
          (_ctx.selectedType == _ctx.FormField.RELATIVE_TIME_RANGE)
            ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                _createElementVNode("div", null, [
                  _createElementVNode("div", _hoisted_10, [
                    _createVNode(_component_MdTextfieldTag, {
                      fieldStyle: "min-width:80px;width: 60px;max-width:60px;",
                      style: {"height":"56px","margin-top":"5px"},
                      class: "fl fs16 mr5",
                      type: `number`,
                      placeholder: `10`,
                      value: _ctx.currentBirthDateOption.start_day || 0,
                      onInputValue: _ctx.inputStartDay,
                      min: -36500,
                      max: 36500,
                      required: ""
                    }, null, 8, ["value", "onInputValue"]),
                    _hoisted_11
                  ]),
                  _createElementVNode("div", _hoisted_12, [
                    _createVNode(_component_MdTextfieldTag, {
                      fieldStyle: "min-width:80px;width: 60px;max-width:60px;",
                      style: {"height":"56px","margin-top":"5px"},
                      class: "fl fs16 mr5",
                      type: `number`,
                      placeholder: `10`,
                      value: _ctx.currentBirthDateOption.end_day,
                      onInputValue: _ctx.inputEndDay,
                      min: -36500,
                      max: 36500,
                      required: ""
                    }, null, 8, ["value", "onInputValue"]),
                    _hoisted_13,
                    _hoisted_14
                  ]),
                  _hoisted_15
                ])
              ]))
            : (_ctx.selectedType == _ctx.FormField.ABSOLUTE_TIME_RANGE)
              ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
                  _createElementVNode("div", _hoisted_17, [
                    _createVNode(_component_Dropdown, {
                      class: "form-group fl",
                      style: {"width":"140px"}
                    }, {
                      dropdown: _withCtx(() => [
                        _createElementVNode("li", null, [
                          _createVNode(_component_DatePicker, {
                            modelValue: _ctx.startDate,
                            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.startDate) = $event)),
                            format: "yyyy/MM/dd",
                            "today-btn": false,
                            "clear-btn": false
                          }, null, 8, ["modelValue"])
                        ])
                      ]),
                      default: _withCtx(() => [
                        _createElementVNode("div", _hoisted_18, [
                          _withDirectives(_createElementVNode("input", {
                            class: "form-control dropdown-toggle",
                            type: "text",
                            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.startDate) = $event))
                          }, null, 512), [
                            [_vModelText, _ctx.startDate]
                          ])
                        ])
                      ]),
                      _: 1
                    }),
                    _hoisted_19,
                    _createVNode(_component_Dropdown, {
                      class: "form-group fl",
                      style: {"width":"140px"}
                    }, {
                      dropdown: _withCtx(() => [
                        _createElementVNode("li", null, [
                          _createVNode(_component_DatePicker, {
                            modelValue: _ctx.endDate,
                            "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.endDate) = $event)),
                            format: "yyyy/MM/dd",
                            "today-btn": false,
                            "clear-btn": false
                          }, null, 8, ["modelValue"])
                        ])
                      ]),
                      default: _withCtx(() => [
                        _createElementVNode("div", _hoisted_20, [
                          _withDirectives(_createElementVNode("input", {
                            class: "form-control dropdown-toggle",
                            type: "text",
                            "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.endDate) = $event))
                          }, null, 512), [
                            [_vModelText, _ctx.endDate]
                          ])
                        ])
                      ]),
                      _: 1
                    }),
                    _hoisted_21
                  ]),
                  _hoisted_22
                ]))
              : _createCommentVNode("", true),
          _createVNode(_component_CheckboxTag, {
            value: ``,
            name: `restrict_date`,
            checked: _ctx.currentBirthDateOption.restrict_date,
            prefix: `restrict_date`,
            onClickCheckbox: _ctx.clickChangeRestrictDate,
            style: {"margin-left":"1px","margin-right":"10px"}
          }, null, 8, ["checked", "onClickCheckbox"]),
          _hoisted_23,
          (_ctx.currentBirthDateOption.restrict_date && !_ctx.field.is_required)
            ? (_openBlock(), _createElementBlock("div", _hoisted_24, " バリデーションを有効にするには必須項目にしてください。 "))
            : _createCommentVNode("", true),
          _hoisted_25,
          _createElementVNode("div", {
            class: "pointer underline dblue mt20",
            onClick: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_ctx.resetPeriod && _ctx.resetPeriod(...args)))
          }, "期間をリセットする")
        ]))
      : (_openBlock(), _createElementBlock("div", _hoisted_26, [
          _createElementVNode("div", {
            class: "pointer underline dblue",
            onClick: _cache[7] || (_cache[7] = 
//@ts-ignore
(...args) => (_ctx.selectPeriod && _ctx.selectPeriod(...args)))
          }, "選択可能な期間を設定する")
        ]))
  ]))
}